import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, FormControl, TextField, Button } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ShippingCard from './ShippingCard';

const useStyles = makeStyles(() => ({
    title: props =>({
        fontSize: 18,
        position: 'relative',
        textAlign: 'center',
        zIndex: 1,
        '&::before': {
            borderTop: `2px solid ${props.options.titleColor}`,
            content:'""',
            position: 'absolute',
            top: '50%',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: -1
        },
        '& span': {
            color: props.options.titleColor,
            background: '#fff',
            padding: '0 12px'
        }
    }),
    titleCart: props => ({
        fontSize: 16,
        fontWeight: 'bold',
        padding: '0 0 10px 00',
        borderBottom: `1px solid ${props.options.titleColor}`,
    }),
    wrapperForm: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 10,
    },
    formControl: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ccc',
        borderRadius: 5,
        padding: '10px',
    },
    label: {
        color: '#000'
    },
    form: {
        margin: '0px 1px 10px 1px',
        padding: '5px 20px 20px 20px',
        background: '#fff',
    },
    button: props =>({
        backgroundColor: props.options.buttonColor,
        borderRadius: 5,
        color: props.options.buttonTextColor,
        padding: '10px',
        "&:hover": {
            backgroundColor: props.options.buttonColor,
        }
    }),
    sectionTitle: props => ({
        fontWeight: 'bold'
    }),
    changeCepText: props => ({
        fontSize: 14,
        fontWeight: '600',
        textDecorationLine: 'underline',
        textAlign: 'right',
        cursor: 'pointer',
        color: '#555'
    }),
    expandButton: props => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        cursor: 'pointer',
        '& p': {
            textAlign: 'center'
        }
    }),
    icon: {
        fontSize: 14,
        margin: '0'
    },
    optionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        marginBottom: 10,
    },
    summaryContainer: {
        background: '#fff',
        padding: '10px 20px',
        margin: '0px 1px 10px 1px',
    },
    summaryLine: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '5px 0px'
    },
    summaryLastLine: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: '1px solid #c5c5c5',
        margin: '7px 0px 0px 0px',
        padding: '7px 0px 0px 0px '
    },
    priceText: props => ({
        fontSize: 14,
        color: '#333',
        fontWeight: '500'
    }),
    subtotalText: {
        fontSize: 14,
        color: '#666'
    },
    totalText: {
        fontSize: 16,
        color: '#333',
        fontWeight: 'bold'
    },
    totalPriceText: props => ({
        fontSize: 18,
        color: '#000',
        fontWeight: 'bold'
    })
}));

const shippingOptions = [
    {
        name: 'Correios Normal (PAC)',
        information: `Prazo de Entrega: até 6 dias.\n14/07/2023`,
        displayPrice: 'R$ 17,21',
        price: 17.21,
    },
    {
        name: 'Correios Expresso (SEDEX)',
        information: `Prazo de Entrega: até 2 dias.\n10/07/2023`,
        displayPrice: 'R$ 19,05',
        price: 19.05,
    },
    {
        name: 'PAC MINI',
        information: `6 a 15 dias úteis`,
        displayPrice: 'R$ 21,50',
        price: 21.50
    },
]

const Shipping = ({ colors, products, enableSummary, isCartScreen }) => {

    const classes = useStyles(colors);

    const [ shippingCalculated, setShippingCalculate ] = useState(isCartScreen ? true : false);
    const [ expandedResults, setExpandedResults ] = useState(false);

    const [ selectedIndex, setSelectedIndex ] = useState(0);

    const getCartPrice = () => {
        let totalValue = 0;

        for(const product of products){
            totalValue = totalValue + product.price
        }


        if(totalValue.toString().search(/[.]/) == -1){
            return `R$ ${totalValue},00`
        }else{
            const format = totalValue.toString().split('.');

            const before = format[1].slice(0,2).length < 2 
                ? `${format[1].slice(0,2)}0`
                : format[1].slice(0,2)

            return `R$ ${format[0]},${before}`
        }
    }

    const getTotalPrice = () => {
        let totalValue = 0;

        for(const product of products){
            totalValue = totalValue + product.price
        }

        if(shippingCalculated){
            totalValue = totalValue + shippingOptions[selectedIndex].price
        }

        if(totalValue.toString().search(/[.]/) == -1){
            return `R$ ${totalValue},00`
        }else{
            const format = totalValue.toString().split('.');

            const before = format[1].slice(0,2).length < 2 
                ? `${format[1].slice(0,2)}0`
                : format[1].slice(0,2)

            return `R$ ${format[0]},${before}`
        }
    }

    return (
        <>
            <div className={classes.form}>
                <p className={classes.title}>
                    <span>Frete</span>
                </p>

                {!shippingCalculated && (
                    <div className={classes.wrapperForm}>
                        <div className={classes.formControl}>
                            <span className={classes.label}>
                                29177-300
                            </span>
                        </div>

                        <Button onClick={() => setShippingCalculate(true)} className={classes.button} variant="contained">Calcular</Button>
                    </div>
                )}

                {shippingCalculated && (
                    <>
                        <div className={classes.optionsContainer}>
                            {shippingOptions.map((item, index) => (
                                <ShippingCard
                                    data={item}
                                    colors={colors}
                                    selectedOption={index == selectedIndex ? true : false}
                                    key={index}
                                    isCartScreen={isCartScreen}
                                />
                            ))}
                        </div>

                        <p onClick={() => setShippingCalculate(false)} className={classes.changeCepText}>
                            Alterar CEP
                        </p>

                    </>
                )}
            </div>

            {enableSummary && (
                <div className={classes.summaryContainer}>
                    <div className={classes.summaryLine}>
                        <span className={classes.subtotalText}>Subtotal</span>
                        <span className={classes.priceText}>{getCartPrice()}</span>
                    </div>
                    {shippingCalculated && (
                        <div className={classes.summaryLine}>
                            <span className={classes.subtotalText} >{shippingOptions[selectedIndex].name}</span>
                            <span className={classes.priceText}>{shippingOptions[selectedIndex].displayPrice}</span>
                        </div>
                    )}
                    <div className={classes.summaryLastLine}>
                        <span className={classes.totalText}>Total</span>
                        <span className={classes.totalPriceText}>
                            {getTotalPrice()}
                        </span>
                    </div>
                </div >
            )}
        </>

    )
}

export default Shipping;